import React from 'react';
import { Navigate } from 'react-router-dom';
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import Navigation from 'Components/Navigation';
import LoadingPageContent from 'Components/LoadingPageContent';
import FrequentAddressSearchPanel from 'Components/FrequentAddressSearchPanel';
import { userService, frequentAddressService } from 'Services';
import _ from 'lodash';
import { withRouter } from 'Components/withRouter';
import { withAuthenticatedUser } from 'Components/withAuthenticatedUser';
import styles from './FrequentAddressQueryPage.module.css';

class EditCell extends React.Component {
    render() {
        return (
            <td colSpan={this.colSpan}>
                <button className="btn btn-dl-green pull-right" onClick={event => {this.props.EditFrequentAddress(event,this.props.dataItem)}}>EDIT</button>
            </td>
        );
    }
}

class DeleteCell extends React.Component {
    render() {
        return (
            <td colSpan={this.colSpan}>
                <button className="btn btn-dl-green pull-right" onClick={event => {this.props.DeleteFrequentAddress(event,this.props.dataItem)}}>DELETE</button>
            </td>
            );
    }
}

class FrequentAddressQueryPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            queryResult: {
                data: [],
                total: 0
            }
        };

        this.handleQuery = this.handleQuery.bind(this);
    }

    handleQuery(formData) {

        frequentAddressService.getFrequentAddresses(formData)
            .then(response => {

                if (response.status === 200) {

                    var sortedData = _.sortBy(response.data, [a => a.company.toLowerCase()]);

                    this.setState({
                        queryResult: {
                            data: sortedData.map(a => {
                                return {
                                    id: a.id,
                                    key: a.key,
                                    company: a.company,
                                    contact: a.contact,
                                    address: a.address1 + '\n' + a.address2,
                                    suburb: a.suburb
                                };
                            }),
                            total: response.total
                        }
                    });
                }

            })
            .catch(error => console.log(error));
    }

    componentDidMount() {
        
        const formData = new FormData(document.getElementById('frequentAddressQueryForm'));
        this.handleQuery(formData);
            
    }

    AddFrequentAddress = () => {
        const formData = new FormData(document.getElementById('frequentAddressQueryForm'));
        var selectedAccount = formData.get("account");
        this.props.router.navigate(('/frequent_address?id=-1'), {
            selectedAccount: selectedAccount
        });
      }

    EditFrequentAddress = (event,record) => {
        event.preventDefault();
        var address_id = record.id;
        this.props.router.navigate('/frequent_address?id=' + address_id);
        // window.alert(user_id);
    }

    EditCell = (props) => <EditCell {...props} EditFrequentAddress={this.EditFrequentAddress} />

    DeleteFrequentAddress = (event, record) => {
        event.preventDefault();

        var confirmation = window.confirm("This will delete the selected address, continue?");

        if (confirmation !== true)
            return;

        var address_id = record.id;
        frequentAddressService.deleteAddress(address_id)
            .then(response => {
                if(response.status === 200) {
                    alert('Frequent Address deleted.');
                    const formData = new FormData(document.getElementById('frequentAddressQueryForm'));
                    this.handleQuery(formData);
                }
            })
            .catch(error => {
                this.setState({
                    error:error
                });
            });
            
    }

    DeleteCell = (props) => <DeleteCell {...props} DeleteFrequentAddress={this.DeleteFrequentAddress} />

    render() {

        var privileges = null;
        var defaultAccount = null;
        var accountOptions = null;

        if (this.props.authenticatedUser) {
            privileges = this.props.authenticatedUser.privileges;
            defaultAccount = this.props.authenticatedUser.default_account;
            accountOptions = this.props.authenticatedUser.accounts;
        }

        var canViewFrequentAddresses = privileges &&
            _.some(privileges, ['description', 'View Frequent Addresses']);
        
        if (!canViewFrequentAddresses)
            return <Navigate to="/Welcome" />

        var canModifyAddresses = privileges && _.some(privileges, ['description', 'Can Modify Addresses']);
        var canDeleteAddresses = privileges && _.some(privileges, ['description', 'Can Delete Addresses']);
        
        return (
            <div id="frequentAddresses">
                <Navigation active="admin" authenticatedUser={this.props.authenticatedUser} />
                <div className="container-fluid padding-lr55 bg-form">
                    <div className="row h3">
                        <div className="col-xs-12">Frequent Addresses</div>
                    </div>
                    <div className="padding-tb10" />
                    <div className="row">
                        <div className="col-sm-12">
                            <FrequentAddressSearchPanel defaultAccount={defaultAccount} accountOptions={accountOptions} onFormSubmit={this.handleQuery}/>
                        </div>
                    </div>
                    
                </div>
                <div className="container-fluid padding-lr55">
                    <div className="padding-tb10" />
                    <Grid
                        styleName="styles.grid"
                        data={this.state.queryResult}
                        resizable
                        >
                        {
                            canModifyAddresses &&
                            <GridToolbar>
                                <button type="button" className="btn btn-default btn-dl-green" onClick={this.AddFrequentAddress}>NEW ADDRESS</button>
                            </GridToolbar>
                        }
                        <GridColumn title="Key" field="key" width="60px"/>
                        <GridColumn title="Company Name" field ="company" width="300px"/>
                        <GridColumn title="Contact Name" field="contact" width="180px"/>
                        <GridColumn title="Address" field="address" width="400px" />
                        <GridColumn title="Suburb" field="suburb" width="200px"/>
                        {
                            canModifyAddresses && <GridColumn field="id" title=" " cell={this.EditCell} width="120px" />
                        }
                        {
                            canDeleteAddresses && <GridColumn field="id" title=" " cell={this.DeleteCell} width="120px" />
                        }
                    </Grid>
                    <div className="padding-tb10" />
                </div>
            </div>
            )
    }
}

const AuthenticatedFrequentAddressQueryPage = withAuthenticatedUser(withRouter(FrequentAddressQueryPage));

export { AuthenticatedFrequentAddressQueryPage as FrequentAddressQueryPage };
